// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filters_T-dKz{margin:0 auto;min-width:0;padding:0 1rem;width:100%}@media only screen and (min-width:1264px){.filters_T-dKz{padding:0 4.8rem}}.filters__desktop_HjLUw .part_DOg0W{flex-wrap:wrap}.filters_T-dKz+.filters_T-dKz{margin-top:2px}.title_aqHnB{display:block;font-size:2rem;font-weight:600;line-height:2.8rem;margin:0 0 1.6rem}@media only screen and (min-width:1264px){.title_aqHnB{font-size:2rem;line-height:3rem}}.part_DOg0W{display:inline-flex;flex-wrap:wrap;grid-gap:16px 8px;gap:16px 8px}.link_5bLVI{border-radius:1.6rem;display:inline-block;font-size:1.4rem;gap:10px;line-height:2rem;-webkit-text-decoration:underline;text-decoration:underline;white-space:nowrap}a.link_5bLVI{--cp-primary_main:var(--cp-black)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filters": "filters_T-dKz",
	"filters__desktop": "filters__desktop_HjLUw",
	"part": "part_DOg0W",
	"title": "title_aqHnB",
	"link": "link_5bLVI"
};
module.exports = ___CSS_LOADER_EXPORT___;
